import {
  CheckCircleOutline,
  Close,
  ErrorOutline,
  Warning,
} from "@mui/icons-material";
import { Stack, Typography, IconButton, CircularProgress } from "@mui/material";
import { Box } from "@mui/system";

import classes from "./CustomAlert.module.scss";
import { AlertProps } from "../../../interface";

export default function CustomAlert({
  severity,
  title,
  content,
  onClose,
}: AlertProps) {
  return (
    <Box
      className={`${classes["custom-alert"]} ${classes[`alert-${severity}`]}`}
    >
      <Stack
        className={classes["alert-container"]}
        direction="row"
        justifyContent="space-between"
        alignItems="center"
      >
        <Stack direction="row" justifyContent="space-between">
          <Box className={classes["alert-icon"]}>
            {severity === "success" && <CheckCircleOutline />}
            {severity === "error" && <ErrorOutline />}
            {severity === "info" && <CircularProgress size={20} />}
            {severity === "warn" && <Warning />}
          </Box>
          <Box>
            <Typography component="h3" className={classes["alert-title"]}>
              {title ? title : severity}
            </Typography>
            <Typography className={classes["alert-content"]}>
              {content}
            </Typography>
          </Box>
        </Stack>
        <Box>
          {onClose && (
            <IconButton
              onClick={onClose}
              disableFocusRipple
              disableRipple
              className={classes["close-btn"]}
            >
              <Close />
            </IconButton>
          )}
        </Box>
      </Stack>
    </Box>
  );
}
